import { forwardRef, type Ref, type SVGProps } from "react";
const IconTrendingFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      d="M28 8h-9a2 2 0 0 0 0 4h4.32L17 19l-5.5-6.32a2 2 0 0 0-1.43-.68 1.92 1.92 0 0 0-1.48.59l-6 6a2 2 0 0 0 2.82 2.82l4.49-4.48 5.6 6.39A2 2 0 0 0 17 24a2 2 0 0 0 1.49-.66L26 15v4a2 2 0 0 0 4 0v-9a2 2 0 0 0-2-2"
    />
  </svg>
);
const ForwardRef = forwardRef(IconTrendingFilledSVG);
ForwardRef.displayName = "IconTrendingFilled";
export { ForwardRef as IconTrendingFilled };
